import { render, staticRenderFns } from "./VisitPermit.vue?vue&type=template&id=d67e866c&"
import script from "./VisitPermit.vue?vue&type=script&lang=js&"
export * from "./VisitPermit.vue?vue&type=script&lang=js&"
import style0 from "./VisitPermit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports